import {AcCapitalize} from './ac-capitalize';

export const AcFormatInitials = name => {
  const arr = name.split(' ');
  const first_letter = arr[0][0];
  const last_letter =
    arr.length === 2 ? arr[1][0] : arr.length > 2 ? arr[arr.length - 1][0] : arr[0][1];
  return AcCapitalize(`${first_letter || ''}${last_letter || ''}`);
};

export default AcFormatInitials;
